export const can = (page, action = "view") => {
  const user = JSON.parse(localStorage.getItem("adminUser"));
  const permissions = JSON.parse(localStorage.getItem("adminPermissions")) || {};
  
  // ✅ ADMIN → FULL ACCESS
  if (user?.role === "admin") return true;

  if (!Array.isArray(permissions)) return false;

  const pagePermission = permissions.find(
    (p) => p.module === page
  );
  
  return pagePermission?.actions?.[action] === true;
};



